import SuspensePopup from "./SuspensePopup";
import {generateBenefitImage} from "../api/ai/ai.api";
import React, {useState} from "react";

const GPTImageGenerationPopup = ({visible, prompt, onClose, onCreateImage, children}) => {
    const [disabledBtn, setDisabledBtn] = useState(false)

    return (
        <SuspensePopup title="AI 이미지 생성" visible={visible}
                       onClose={() => onClose()}
                       confirmText={<div className="flex">이미지 생성</div>}
                       confirmDisabled={disabledBtn}
                       onConfirm={() => {
                           setDisabledBtn(true)
                           generateBenefitImage(prompt).then(({data}) => {
                               if (!data.includes("https")) {
                                   alert(data)
                               } else {
                                   onCreateImage(data)
                               }
                               setDisabledBtn(false)
                               onClose()
                           }).catch((e) => {
                               // AI 생성 실패(503) — 사유 alert 후 버튼 복구. 종전엔 500 → /notfound 튕김.
                               alert(e?.message || "AI 이미지 생성에 실패했습니다. 잠시 후 다시 시도해 주세요.");
                               setDisabledBtn(false)
                           })
                       }}
        >
            {children}
        </SuspensePopup>
    )
}

export default GPTImageGenerationPopup